var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClpFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0h45v22.5h-45V0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22.5v22.5H0V0Z",
    fill: "#0039A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.748 16.849-3.48-2.61-3.472 2.636 1.292-4.29L5.625 9.94l4.28-.044 1.327-4.271 1.363 4.263 4.28.008-3.445 2.672 1.318 4.28Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 22.5h67.5V45H0V22.5Z",
    fill: "#D52B1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v45H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClpFlag);
export default __webpack_public_path__ + "static/media/clp-flag.7ed9d7ffb17e6926324bbd1739a631e9.svg";
export { ForwardRef as ReactComponent };